/* unplugin-vue-components disabled */import { render } from "./DynamicBuilder.vue?vue&type=template&id=6a1eac9f"
import script from "./DynamicBuilder.vue?vue&type=script&lang=js"
export * from "./DynamicBuilder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__